<template lang="pug">
v-app
	v-app-bar(app)
		v-toolbar-title
			i.fas.fa-cogs.fa-2x.mr-2
			| Engenho Novo do Povo

		v-spacer

		v-btn(text href='/' target='_self')
			span.mr-2 Swaptions

	v-content
		HelloWorld
</template>

<style lang="sass">

v-toolbar-title.headline
	font-family: "News Cycle", sans-serif

</style>

<script>
import HelloWorld from './components/HelloWorld';

export default {
	name: 'App',
	components: {
		HelloWorld,
	},
	data: () => ({
		//
	}),
};
</script>
